// JavaScript to combine fields into note
// document.addEventListener("DOMContentLoaded", function () {
//   const form = document.querySelector("form.newsletter-form");

//   const firstName = document.querySelector("#NewsletterForm--firstName");
//   const lastName = document.querySelector("#NewsletterForm--lastName");
//   const dob = document.querySelector("#NewsletterForm--DOB");
//   const noteField = document.querySelector("#ContactNote");

//   if (form && firstName && lastName && dob && noteField) {
//     form.addEventListener("submit", function () {
//       const fn = firstName.value.trim();
//       const ln = lastName.value.trim();
//       const birth = dob.value;

//       let note = '';
//       if (fn) note += `First Name: ${fn}\n`;
//       if (ln) note += `Last Name: ${ln}\n`;
//       if (birth) note += `DOB: ${birth}`;

//       noteField.value = note;
//     });
//   }
// });

document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector("form.newsletter-form");

  const firstName = document.querySelector("#NewsletterForm--firstName");
  const lastName = document.querySelector("#NewsletterForm--lastName");
  const dob = document.querySelector("#NewsletterForm--DOB"); // hidden date input
  const dobDisplay = document.querySelector("#NewsletterForm--DOB-display"); // visible text input
  const noteField = document.querySelector("#ContactNote");

  // Show datepicker when clicking text field
  if (dobDisplay && dob) {
    dobDisplay.addEventListener("click", function () {
      dob.showPicker ? dob.showPicker() : dob.focus(); // modern and fallback
    });

    dob.addEventListener("change", function () {
      if (dob.value) {
        const dateObj = new Date(dob.value);
        const formatted = `${dateObj.getMonth() + 1}`.padStart(2, '0') + '/' +
                          `${dateObj.getDate()}`.padStart(2, '0') + '/' +
                          dateObj.getFullYear();
        dobDisplay.value = formatted;

        // Hide the label
        const label = document.querySelector("label[for='NewsletterForm--DOB-display']");
        if (label) {
          label.style.display = "none";
        }
      }
    });
  }

  // Submit handling
  if (form && firstName && lastName && dob && noteField) {
    form.addEventListener("submit", function () {
      const fn = firstName.value.trim();
      const ln = lastName.value.trim();
      const birth = dob.value;

      let note = '';
      if (fn) note += `First Name: ${fn}\n`;
      if (ln) note += `Last Name: ${ln}\n`;
      if (birth) note += `DOB: ${birth}`;

      noteField.value = note;
    });
  }
});
